export function mapToggle() {
  const mapContents = document.querySelectorAll(".js-map");
  if (!mapContents.length) return;

  mapContents.forEach((contents) => {
    const trigger = contents.querySelector(".p-map__trigger");
    const base = contents.querySelector(".p-map__content--base");
    const overlay = contents.querySelector(".p-map__content--overlay");
    const sectionInner = contents.closest(".p-map__inner");
    const buttonWrapper = sectionInner?.querySelector(".p-map__button") ?? null;
    const externalButton = sectionInner?.querySelector(".js-map-button") ?? null;
    if (!trigger || !base || !overlay) return;

    const hideButton = () => {
      buttonWrapper?.classList.add("is-hidden");
    };

    const showButton = () => {
      buttonWrapper?.classList.remove("is-hidden");
    };

    const syncAriaExpanded = (isExpanded) => {
      const value = isExpanded ? "true" : "false";
      trigger.setAttribute("aria-expanded", value);
      if (externalButton) {
        externalButton.setAttribute("aria-expanded", value);
      }
    };

    const clearExpandedHeight = () => {
      contents.style.minHeight = "";
    };

    const open = () => {
      contents.style.minHeight = `${contents.offsetHeight}px`;
      contents.classList.add("is-active");
      syncAriaExpanded(true);
      overlay.setAttribute("aria-hidden", "false");

      requestAnimationFrame(() => {
        contents.style.minHeight = `${overlay.offsetHeight}px`;
      });

      hideButton();
    };

    const close = () => {
      contents.classList.remove("is-active");
      syncAriaExpanded(false);
      overlay.setAttribute("aria-hidden", "true");
      contents.style.minHeight = `${base.offsetHeight}px`;
      showButton();

      overlay.addEventListener(
        "transitionend",
        function onTransitionEnd(event) {
          if (event.propertyName !== "opacity") return;
          clearExpandedHeight();
          overlay.removeEventListener("transitionend", onTransitionEnd);
        }
      );
    };

    const toggle = () => {
      if (contents.classList.contains("is-active")) {
        close();
      } else {
        open();
      }
    };

    trigger.addEventListener("click", toggle);
    if (externalButton) {
      externalButton.addEventListener("click", () => {
        if (!contents.classList.contains("is-active")) {
          open();
        }
      });
    }
    overlay.addEventListener("click", () => {
      if (contents.classList.contains("is-active")) {
        close();
      }
    });

    window.addEventListener("resize", () => {
      if (!contents.classList.contains("is-active")) return;
      contents.style.minHeight = `${overlay.offsetHeight}px`;
    });
  });
}
